import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AbstractBffApi} from '../../models/sharedinterface';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {ActivatedRoute} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import {GlobalsService} from '../../shared/services/globals.service';

@Component({
  selector: 'app-passwordresetview',
  templateUrl: './passwordresetview.component.html',
  styleUrls: ['./passwordresetview.component.scss']
})
export class PasswordresetviewComponent implements OnInit {

  resetForm: UntypedFormGroup;
  submitted: boolean;

  showPasswords: boolean;

  public error: string;

  private token: string;
  private userId: number;

  bffapi: AbstractBffApi;

  constructor(private fb: UntypedFormBuilder, private apifactory: ApiFactoryService, protected route: ActivatedRoute,
              private globalsservice: GlobalsService) {
    this.resetForm = new UntypedFormGroup({});
    this.bffapi = this.apifactory.createBffApi();
    this.showPasswords = false;
  }

  ngOnInit(): void {
    this.submitted = false;
    this.resetForm = this.fb.group({
      password: ['', [
        Validators.required, Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])(?=.*[§°+¦"@*#ç°%§&¬/¢()=?´`~\]\[!\-_^{},.:;/\\<>]).{12,}$/)
      ]
      ],
      passwordConfirm: ['', Validators.required]
    }, {validator: this.checkSamePasswords});

    // Checks if user has a valid token
    this.token = this.route.snapshot.paramMap.get('token');
    this.userId = Number(this.route.snapshot.paramMap.get('userId'));
  }

  onSubmitNewPasswordForm() {

    if (this.resetForm.valid) {

      const newPasswordData =
        this.userId + this.globalsservice.getCredentialSeparator() +
        this.token + this.globalsservice.getCredentialSeparator() +
        this.resetForm.value.password;
      const encryptedWord = CryptoJS.enc.Utf8.parse(newPasswordData); // encryptedWord Array object
      const encryptedNewPasswordData = CryptoJS.enc.Base64.stringify(encryptedWord);

      const query = this.bffapi.setNewPassword(encryptedNewPasswordData);
      query.subscribe((data) => {
          console.log(data);
          this.submitted = true;
        },
        error => {
          if (error.status === 0) {// Unknown error - service not responding
            this.error = 'Network error. Please try again later.';
          } else if (error.status === 400) {// Bad request
            this.error = 'Your reset password link is not valid.';
          }
          this.submitted = true;
        });

    }
  }

  checkSamePasswords(group: UntypedFormGroup) {
    const password = group.get('password').value;
    const passwordConfirm = group.get('passwordConfirm').value;
    return password === passwordConfirm ? null : {notSamePassword: true};
  }

}
